// src/components/ads/GA4PageViews.tsx
import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { ga4PagePath, trackGA4PageView } from '../../lib/ga4'

/** Sends one GA4 page_view per client-side route change. Renders nothing.
 *  An SPA with the stock gtag snippet counts only the first load, and the
 *  ad networks read GA4 page views to verify traffic.
 *
 *  Dev StrictMode runs this effect twice against the same location -
 *  `send_page_view: false` only suppresses GA4's OWN automatic event, so
 *  without a guard the initial route would send a duplicate. Track the last
 *  sent path+search and skip a re-fire for the same location; a real route
 *  change still sends. */
export default function GA4PageViews() {
  const location = useLocation()
  const lastSent = useRef<string | null>(null)
  useEffect(() => {
    const key = ga4PagePath(location.pathname, location.search)
    if (lastSent.current === key) return
    lastSent.current = key
    trackGA4PageView(key, document.title)
  }, [location.pathname, location.search])
  return null
}
